import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  position: relative;
  margin-top: 2rem;
  padding: clamp(3rem, 5vw, 4.5rem) 0 2rem;
`;

export const FooterShell = styled("div")`
  position: relative;
  padding: clamp(1.5rem, 4vw, 2.5rem);
  border-radius: 36px;
  background: linear-gradient(160deg, rgba(31, 23, 64, 0.97), rgba(62, 38, 103, 0.94));
  box-shadow: var(--shadow-strong);
  overflow: hidden;
`;

export const FooterGlow = styled("div")`
  position: absolute;
  inset: auto auto 0 -4rem;
  width: 18rem;
  height: 18rem;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 200, 92, 0.25), rgba(255, 200, 92, 0));
  filter: blur(10px);
  pointer-events: none;
`;

export const FooterGrid = styled("div")`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) repeat(3, minmax(0, 0.85fr));
  gap: 1.5rem;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const BrandColumn = styled("div")`
  display: grid;
  gap: 1rem;
`;

export const BrandMark = styled("img")`
  width: 138px;
  height: auto;
`;

export const BrandCopy = styled("p")`
  max-width: 30ch;
  color: rgba(255, 255, 255, 0.76);
`;

export const FooterTitle = styled("h2")`
  font-size: 1rem;
  color: #fff;
  margin-bottom: 0.9rem;
`;

export const LinkStack = styled("nav")`
  display: grid;
  gap: 0.6rem;
`;

export const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.76);
  font-weight: 600;

  &:hover,
  &:focus-visible {
    color: #fff;
  }
`;

export const FooterAnchor = styled("a")`
  color: rgba(255, 255, 255, 0.76);
  font-weight: 600;

  &:hover,
  &:focus-visible {
    color: #fff;
  }
`;

export const SocialRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.9rem;
  margin-top: 0.6rem;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    transition: transform 0.2s ease, background 0.2s ease;
  }

  a:hover,
  a:focus-visible {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const FooterBottom = styled("div")`
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  margin-top: 2rem;
  padding-top: 1.4rem;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.92rem;
`;
